import { PickType } from '@nestjs/swagger';
import { JobRepairNoteDto } from './job-repair-note.dto';
import { JobRepairNoteCreatableInterface } from '../interfaces/job-repair-note-creatable.interface';

export class JobRepairNoteCreateDto
  extends PickType(JobRepairNoteDto, [
    'text',
    'jobRepairId',
    'jobRepairNoteType',
  ])
  implements JobRepairNoteCreatableInterface {}
